import {
  checkPreconditionStatusRequest,
  emailContentModificationRequest,
  emailContentRequest,
  emailTemplatesRequest,
  fetchAttachmentRequest,
  fetchConceptsRequest,
  fetchCustomerProfileDataRequest,
  fetchEcomPackagesRequest,
  fetchEcommDataRequest,
  getDeliveryRequest,
  listCustomers as listCustomersRequest,
  requestFetchModulesCalled,
  requestModulesSave,
  searchUserRequest,
  sendConfirmationRequest
} from '@cbgms/api/modules/customers/requests'
import { GETCompaniesResponse } from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { store } from '../../../../state/store'

export interface EcomPackage {
  ModuleID: string
  ModuleName: string
  Price: number
  AppID: string
}

export interface EcomPackagesResponse {
  Data: EcomPackage[]
}
interface FormattedModule {
  AppId: string
  IsBasePackage: boolean
  IsSearchFilter: boolean
  ModuleId: string
  ModuleName: string
  ModuleStoreFlag: number | null
  TopMotiveFlag: number
}

interface FormattedData {
  Modules: FormattedModule[]
}

export const listCustomers = (params: IPaginatedRequest) => {
  const currentState = store.getState()
  const emailAddress = currentState?.auth?.user?.email
  const role = currentState?.auth?.user?.['custom:role']
  const ouName = currentState?.auth?.user?.['ou_name']
  const appid = currentState?.auth?.user?.['AppId']
  const initialQuery = `Customer.OuName|=|${ouName}`
  params.search = params.search ? `${initialQuery},${params.search}` : initialQuery

  return AsyncAction<GETCompaniesResponse>({
    type: [types.GET_CUSTOMERS, types.GET_CUSTOMERS_SUCCESS, types.GET_CUSTOMERS_FAILED],
    payload: {
      api: 'support',
      request: listCustomersRequest(params, role, emailAddress, appid)
    }
  })
}

export const searchCustomers = (data: any) => {
  const currentState = store.getState()
  const emailAddress = currentState?.auth?.user?.email
  const role = currentState?.auth?.user?.['custom:role']
  if (role !== 'dach_telesales') {
    data.SalesRep = ''
  } else {
    data.SalesRep = emailAddress
  }
  return AsyncAction<any>({
    type: [types.SEARCH_CUSTOMER, types.SEARCH_CUSTOMER_SUCCESS, types.SEARCH_CUSTOMER_FAILED],
    payload: {
      api: 'support',
      request: searchUserRequest(data)
    }
  })
}

import { FiltrerAction } from './types'

export const UPDATE_QUERY = 'UPDATE_QUERY'
export const UPDATE_MODULE_ID = 'UPDATE_MODULE_ID'
export const UPDATE_ACTIVATION_STATUS = 'UPDATE_ACTIVATION_STATUS'
export const UPDATE_ECOMMERCE_STATUS = 'UPDATE_ECOMMERCE_STATUS'
export const RESET_FILTERS = 'RESET_FILTERS'
export const UPDATE_APP_ID = 'UPDATE_APP_ID'
export const UPDATE_OU_NAME = 'UPDATE_OU_NAME'

export function updateQuery(query: string): FiltrerAction {
  return { type: UPDATE_QUERY, payload: query }
}
export function updateAppId(query: string): FiltrerAction {
  return { type: UPDATE_APP_ID, payload: query }
}
export function updateOuName(query: string): FiltrerAction {
  return { type: UPDATE_OU_NAME, payload: query }
}

export const getDelivery = (CustNo: string, ShipToLoc: string, OuName: string, AppId: string, CustomerEosId: string) => ({
  type: [types.GET_DELIVERY, types.GET_DELIVERY_SUCCESS, types.GET_DELIVERY_FAILED],
  payload: {
    api: 'support',
    request: getDeliveryRequest(CustNo, ShipToLoc, OuName, AppId, CustomerEosId)
  },
  Data: []
})

export const checkPreconditionStatus = (CustNo: string, ShipToLoc: string, OuName: string, AppId: string, CustomerEosId: string) => ({
  type: [types.PRECONDITION_STATUS_CHECK, types.PRECONDITION_STATUS_CHECK_SUCCESS, types.PRECONDITION_STATUS_CHECK_FAILED],
  payload: {
    api: 'support',
    request: checkPreconditionStatusRequest({
      CustNo,
      ShipToLoc,
      OuName,
      AppId,
      CustomerEosId
    })
  },
  Data: []
})

export const fetchModulesCalled = (ouName: string) => ({
  type: [types.GET_MODULES, types.GET_MODULES_SUCCESS, types.GET_MODULES_FAILED],
  payload: {
    api: 'support',
    request: requestFetchModulesCalled(ouName)
  },
  Data: []
})

export const fetchModulesSave = (formattedData: FormattedData) => ({
  type: [types.GET_MODULES_SAVE, types.GET_MODULES_SAVE_SUCCESS, types.GET_MODULES_SAVE_FAILED],
  payload: {
    api: 'support',
    request: requestModulesSave(formattedData)
  },
  Data: {}
})

export const fetchEcommData = (extractedData: { CustEosID: string; OuName: string; AppId: string }) => {
  return AsyncAction<any>({
    type: [types.GET_ECOMM_DATA, types.GET_ECOMM_DATA_SUCCESS, types.GET_ECOMM_DATA_FAILED],
    payload: {
      api: 'support',
      request: fetchEcommDataRequest(extractedData) // Pass the entire object
    }
  })
}
export const fetchCustomerProfileData = (CustEosID: string) => {
  return AsyncAction<any>({
    type: [types.GET_CUSTOMER_PROFILE_DATA, types.GET_CUSTOMER_PROFILE_DATA_SUCCESS, types.GET_CUSTOMER_PROFILE_DATA_FAILED],
    payload: {
      api: 'support',
      request: fetchCustomerProfileDataRequest(CustEosID)
    }
  })
}

export const fetchConcepts = (extractedConcept: { CustEosID: string; OuName: string; AppId: string }) => {
  return AsyncAction<any>({
    type: [types.GET_CONCEPTS_PROFILE, types.GET_CONCEPTS_PROFILE_SUCCESS, types.GET_CONCEPTS_PROFILE_FAILED],
    payload: {
      api: 'support',
      request: fetchConceptsRequest(extractedConcept) // Use the request function
    }
  })
}

export const fetchEcomPackages = (customerNumber: string, App_Id: string, ou_name: string) => {
  return AsyncAction<EcomPackagesResponse>({
    type: [types.GET_ECOM_PACKAGES_REQUEST, types.GET_ECOM_PACKAGES_SUCCESS, types.GET_ECOM_PACKAGES_FAILURE],
    payload: {
      api: 'support',
      request: fetchEcomPackagesRequest(customerNumber, App_Id, ou_name)
    }
  })
}

export const sendConfirmationEmail = (orderRequestBody: any) => {
  return {
    type: [types.SEND_CONFIRMATION_EMAIL, types.SEND_CONFIRMATION_EMAIL_SUCCESS, types.SEND_CONFIRMATION_EMAIL_FAILED],
    payload: {
      api: 'support',
      request: sendConfirmationRequest(orderRequestBody)
    }
  }
}

export const emailContentModification = (requestBody: object) => ({
  type: [types.EMAIL_CONTENT_MODIFICATION, types.EMAIL_CONTENT_MODIFICATION_SUCCESS, types.EMAIL_CONTENT_MODIFICATION_FAILED],
  payload: {
    api: 'support',
    request: emailContentModificationRequest(requestBody)
  },
  Data: {}
})

export const fetchAttachments = (App_Id: string) => {
  return AsyncAction<any>({
    type: [types.FETCH_ATTACHMENT, types.FETCH_ATTACHMENT_SUCCESS, types.FETCH_ATTACHMENT_FAILED],
    payload: {
      api: 'support',
      request: fetchAttachmentRequest(App_Id)
    }
  })
}

export const fetchEmailTemplates = (App_Id: string) => {
  return AsyncAction<any>({
    type: [types.FETCH_EMAIL_TEMPLATES, types.FETCH_EMAIL_TEMPLATES_SUCCESS, types.FETCH_EMAIL_TEMPLATES_FAILED],
    payload: {
      api: 'support',
      request: emailTemplatesRequest(App_Id)
    }
  })
}

export const fetchEmailContent = (emailTemplateUUID: string) => {
  return AsyncAction<any>({
    type: [types.FETCH_EMAIL_CONTENT, types.FETCH_EMAIL_CONTENT_SUCCESS, types.FETCH_EMAIL_CONTENT_FAILED],
    payload: {
      api: 'support',
      request: emailContentRequest(emailTemplateUUID)
    }
  })
}
